<div>
  <span *ngIf="isExpanded">{{fullText}}</span>
  <span *ngIf="!isExpanded">{{shortText}}</span>
  <span *ngIf="fullText.length > maxLength">
    &nbsp;
    <a *ngIf="!isExpanded"
       href="javascript:void(0);"
       (click)="isExpanded = !isExpanded">show more</a>
    <a *ngIf="isExpanded"
       href="javascript:void(0);"
       (click)="isExpanded = !isExpanded">show less</a>
  </span>
</div>
